import React from "react";
import { PageContainer, PageContentView } from "components/shared";
import AddressAndPhoneNumberWidget from "./components/AddressAndPhoneNumberWidget ";
import EmailAddressWidget from "./components/EmailAddressWidget";

import "./styles.css";

/**
 * @function ACTContactInfoPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ACTContactInfoPage
 */
export default function ACTContactInfoPage(props) {
  return (
    <PageContainer className="act-contact-info-page">
      <PageContentView>
        <div className="flex-container flex-vertical flex-width">
            <AddressAndPhoneNumberWidget />
            <EmailAddressWidget />
        </div>
      </PageContentView>
    </PageContainer>
  )
}
